<template>
  <div class="container">
    <!-- <div class="daily_tab">
      <img @click="handleBack" style="width: 0.32rem; height: 0.59rem" src="../assets/back.png" />
      <div>日报趋势</div>
    </div> -->
    <van-nav-bar title="日报趋势" @click-left="handleBack">
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333" />
      </template>
    </van-nav-bar>
    <div class="company_selection" @click="selectCompanyHandler">
      <span>{{ companyName }}</span>
      <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
    </div>
    <div class="report_search">
      <div
        style="display:flex;
          align-items: center;
          border:1px solid;
          height: 26px;
          border-color:#dddddd;
          border-radius:4px;
          padding: 4px;"
        @click="showSelectDate"
      >
        <div>{{ currentDate }}</div>
        <i class="iconfont icon-xiangxiajiantou"></i>
      </div>
      <div class="end_date">数据截止时间：{{ currentDateStr }}</div>
    </div>
    <div class="daily_header">
      <div>日期</div>
      <div>已提交</div>
      <div>补交</div>
      <div>应提交</div>
      <div>提交率</div>
    </div>
    <div class="daily_item" v-for="(item, index) in data" :key="index">
      <div v-if="type === 'day'">{{ dayjs(item.reportDate).format("MM-DD") }}</div>
      <div v-else>{{ item.reportMonth }}</div>
      <div>{{ item.submittedNum }}</div>
      <div>{{ item.supplementNum }}</div>
      <div>{{ item.shouldSubmitNum }}</div>
      <div>{{ item.submitRate }}</div>
    </div>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker v-model="selectedDate" type="year-month" :formatter="formatter" title="选择年月" @confirm="dateConfirm" @cancel="showDatePicker = false" />
    </van-action-sheet>
    <van-action-sheet v-model="showYearPicker">
      <van-picker show-toolbar v-model="selectedDate" :defaultIndex="defaultIndex" :columns="yearOptions" @confirm="yearConfirm" @cancel="showYearPicker = false" />
    </van-action-sheet>
  </div>
</template>

<script>
import { getReportStatisticsTrendList } from "@/axios/services";
import dayjs from "dayjs";
import VeiBanBridge from "@/utils/bridge";
export default {
  data() {
    return {
      currentDate: "",
      currentDateStr: this.getDate("yyyy-MM-dd", "yesterday"),
      currentMonth: new Date(),
      currentMonthStr: this.getCurrentMonth(new Date()),
      data: [
        {
          date: "2022-10",
          num1: "100",
          num2: "10",
          num3: "120",
          num4: "90%",
        },
      ],
      showDatePicker: false,
      showYearPicker: false,
      selectedDate: "",
      type: "",
      companyId: "",
      officeId: "",
      yearOptions: (() => {
        let opts = [];
        for (var i = 1990; i <= 2300; i++) {
          opts.push(i);
        }
        return opts;
      })(),
      selectedCompany: [],
      companyName: "",
      scopeType: ''
    };
  },
  computed: {
    defaultIndex() {
      let index = this.yearOptions.findIndex((el) => el === this.selectedDate);
      return index;
    },
  },
  methods: {
    dayjs,
    getDate(format = "yyyy-MM-dd", type) {
      let date = null;
      type = type || "today";
      let now = +Date.now();
      let oneDay = 1000 * 60 * 60 * 24;
      let yesterday = now - oneDay;
      const typeDes = ["yesterday", "today"];
      if (typeDes.includes(type)) {
        date = type === "yesterday" ? new Date(yesterday) : new Date();
      } else {
        date = new Date(type);
      }
      if (date.toString() === "Invalid Date") {
        return;
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    handleBack() {
      this.$router.back();
    },
    selectCompanyHandler() {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany),
        },
      });
    },
    getCurrentMonth(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1);
    },
    getCurrentYear(date) {
      return date.getFullYear();
    },
    getCurrentDay(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1) + "-" + this.checkTime(date.getDate());
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else {
        return `${val}日`;
      }
    },
    showSelectDate() {
      if (this.type === "day") {
        this.showDatePicker = true;
      } else {
        this.showYearPicker = true;
      }
    },
    dateConfirm(date) {
      this.showDatePicker = false;
      this.currentDate = this.type === "day" ? dayjs(this.selectedDate).format("YYYY-MM") : dayjs(this.selectedDate).format("YYYY");
      this.getData();
    },
    yearConfirm(date) {
      this.showYearPicker = false;
      if (this.selectedDate === date) {
        return;
      }
      this.selectedDate = date;
      this.currentDate = date;
      this.getData();
    },
    getData() {
      if (this.type === "day") {
        const params = {
          companyId: this.companyId,
          officeId: this.officeId,
          reportMonth: this.currentDate,
        };
        if(this.scopeType == 0) {
          params.blocFlag = 'Y'
        }
        getReportStatisticsTrendList(params).then((res) => {
          if (res.data.code === 0) {
            this.data = res.data.data;
          }
        });
      } else {
        const params = {
          companyId: this.companyId,
          officeId: this.officeId,
          reportYear: this.currentDate,
        };
        if(this.scopeType == 0) {
          params.blocFlag = 'Y'
        }
        getReportStatisticsTrendList(params).then((res) => {
          if (res.data.code === 0) {
            this.data = res.data.data;
          }
        });
      }
    },
    getYesterday() {
      let day = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      this.selectedDate = day;
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path === "/select-data-range") {
  //     let params = from.params?.selectedData || [];
  //     next((vm) => {
  //       if (params.length) {
  //         vm.selectedCompany = params;
  //         let selected = params[params.length - 1];
  //         vm.companyName = selected.name;
  //         vm.scopeType = selected.type;
  //         vm.companyId = selected.companyId;
  //         vm.officeId = selected.officeId;
  //       }
  //     });
  //   } else {
  //     next();
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/select-data-range" || from.path === "/personal-report-board") {
      let params = null;
      let selcetDate = "";
      if (from.path === "/select-data-range") {
        params = from.params?.selectedData || [];
      } else if (from.path === "/personal-report-board") {
        params = to.query?.seletionData ? JSON.parse(to.query?.seletionData) : [];
        selcetDate = to.query?.selectionDate;
      }
      next((vm) => {
        // vm.seletionDateData.selectedDate = selcetDate;
        // vm.selectedDate = new Date(selcetDate);
        if (params.length) {
          vm.selectedCompany = params;
          let selected = params[params.length - 1];
          vm.companyName = selected?.name;
          vm.scopeType = selected?.type;
          if (selected.type == 0 || selected.type == 1) {
            vm.companyId = selected.id;
            vm.officeId = "";
          } else if (selected.type == 2) {
            vm.companyId = "";
            vm.officeId = selected.id;
          }
          // vm.currentPage = 1;
          // vm.dailyList = [];
        }
      });
    } else {
      next();
    }
  },
  async created() {
    const user = (await VeiBanBridge.getUserInfo()) || {};
    // const { companyName, companyId } = user;
    this.companyId = this.companyId ? this.companyId : user?.companyId;
    this.companyName = this.companyName ? this.companyName : user?.companyName;
    this.type = this.$route.query?.type == "天" ? "day" : "month";
    if (this.type === "day") {
      this.currentDate = dayjs(this.$route.query.date).format("YYYY-MM");
      this.selectedDate = new Date(this.currentDate);
    } else {
      this.currentDate = dayjs(this.$route.query.date).format("YYYY");
      this.selectedDate = Number(dayjs(this.$route.query.date).format("YYYY"));
    }
    // this.getYesterday();
    // this.selectedDate = new Date(this.$route.query.date);
    // this.currentDate = dayjs(this.$route.query.date
    this.getData();
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  background: #f9f9f9;
  position: relative;
  /* padding-top: 1.71rem; */
}
.daily_tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.daily_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.company_selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}
.report_search {
  height: 1.2rem;
  margin-top: 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;
}
.daily_header {
  width: 100%;
  height: 1.5rem;
  margin-top: 10px;
  font-family: Source Han Sans CN;
  font-weight: 700;
  color: #333333;
  font-size: 14px;
  background: #ffffff;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 1px solid #ccc;
}
.daily_header div {
  width: 25%;
  margin-left: 10px;
}
.daily_item {
  width: 100%;
  height: 1.5rem;
  /* margin-top: 10px; */
  font-family: Source Han Sans CN;
  color: #333333;
  font-size: 14px;
  background: #ffffff;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 1px solid #ccc;
}
.daily_item div {
  width: 25%;
  margin-left: 10px;
  font-family: Source Han Sans CN;
  color: #666666;
  font-size: 14px;
}
.end_date {
  font-family:Source Han Sans CN;
  color:#999999;
  font-size:12px;
  line-height:12px;
}
</style>
